import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import TabItems from "./TabItems";
import "./courseView.css";
import Course from "../course/Course";
import thumbnailImg from "../../template/images/course_thumbnail.png";
import courseMainImg from "../../template/images/course_main.png";
import courseBottomImg from "../../template/images/course_bottom.png";
import courseCurriculumImage from "../../template/images/courseCurriculumImage.png";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import PopularCourse from "../popularCourse/PopularCourse";
import { get, post } from "../../util/axiosConfig/AxiosConfig";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import StarRatings from "react-star-ratings";


const CourseView = () => {
  const { courseId } = useParams();
  const [loading, setLoading] = useState(false);
  const [coursesDataDetails, setCoursesDataDetails] = useState([]);
  const [popularCourseData, setPopularCoursesData]  = useState([]);
  const [htmlContent, setHTMLContent] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);


  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCoursesDataDetails();
   
      // Replace with your API endpoint
 
   
  }, []);



  const fetchCoursesDataDetails = async () => {
    // console.log(courseId, "iddddddddddddddd");
    try {
      setLoading(true);
      const response = await get(
        `web/api/v1/lms-web/open/get-course-details/${courseId}`
      );
      setCoursesDataDetails(response);
      fetchPopularCourseData(response.trainer.id)
      // setTrainerUserId(response.trainer.userId)
      // console.log(response.overview)
      setHTMLContent(response?.overview)
    } catch (error) {
      setLoading(false);
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPopularCourseData = async (id) => {
    try {
      
      setLoading(true);
      const response = await get(`web/api/v1/lms-web/open/get-course-list-by-trainer/${id}`);
      setPopularCoursesData(response);
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTabClick = (
    (val) => {
      console.log("val",val)
      setSelectedTab(val)
    }
  )


  const manageEnroll = () => {
    navigate(`/subscription/${courseId}`)
  }

  function getTrainerFullName(trainer) {

    let fullName = '';
     fullName = trainer.firstName;
    if (trainer.middleName) {
        fullName += " " + trainer.middleName;
    }
    if (trainer.lastName) {
        fullName += " " + trainer.lastName;
    }
    return fullName;
}
const handleSubscription = () => {
  navigate(`/subscription/${courseId}`)
}

const handleBuyNow = () => {
  navigate(`/CreateAccount`)
  localStorage.setItem("unit",courseId)
  localStorage.setItem("type",coursesDataDetails.courseTypeId == 2 ? "Short" : "Standard") 
  localStorage.setItem("activeOffer",coursesDataDetails.isActiveOffer) 
  if(coursesDataDetails.isActiveOffer) {
      localStorage.setItem('offerPrice', coursesDataDetails.offerPrice)
  } else {
      localStorage.removeItem('offerPrice', coursesDataDetails.offerPrice)

  }
}

const handleTeamsRedirect = () => {
  navigate('/EnquiryForm?cataGory='+1+'&courseId='+courseId);
}


  return (
    <React.Fragment>
      <Header />
      {/* <div className="all_content">
            <div className="banner_left"></div>
            <div className="banner_middle">
              <h4 className="banner_course_title">{coursesDataDetails.courseName}</h4>
              <p className="view_amount">₹ {coursesDataDetails.minPrice} /-</p>
              <div className="course_ftr">
                  <button className="course_individual_btn">Individual</button>
                  <button className="course_teams_btn">Teams</button>
              </div>
            </div>
            <div className="banner_right">
            </div>
      </div> */}

          {/* <div className="course_form_main">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <img src={courseMainImg} className="course_main_img"></img>
                  </div>
                  <div className="banner_right col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <h4 className="banner_course_title">{coursesDataDetails.courseName}</h4>
                    <p className="view_amount">₹ {coursesDataDetails.minPrice} /-</p>
                    <div className="course_button_position">
                        <button className="course_individual_btn_first">Individual</button>
                        <button className="course_teams_btn_first">Teams</button>
                    </div>
                  </div>
                </div>
          </div> */}
                            


      <div className="course_banner_sectioon">
      <div className="course_form_main">
                <div className="row g-0">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="course_main_img">
                      <img src={coursesDataDetails.coverImage} className={!coursesDataDetails.feedbackShowInWeb || coursesDataDetails.feedbackAvg == 0.0 ? "course_start_image" : "course_start_image_rating"}></img>
                    </div>
                  </div>
                  <div className=" col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div className="banner_right">
                    <h4 className={!coursesDataDetails.feedbackShowInWeb || coursesDataDetails.feedbackAvg == 0.0 ? "banner_course_title" : "banner_course_title_rating"}>{coursesDataDetails.courseName}</h4>
                    {coursesDataDetails.feedbackShowInWeb && coursesDataDetails.feedbackAvg > 0.0 ?
                    <>
                    <div className="ratingBodyDesigns">
                        <div className="ratingNumbers">
                            <span className="ratingNumberStyles">{coursesDataDetails.feedbackAvg.toFixed(1)}</span>
                        </div>
                        <div className="ratingStar">
                                  {/* <p className="ratingDescription"></p> */}
                                  
                                  <StarRatings
                                  rating={coursesDataDetails.feedbackAvg}
                                  starRatedColor="#FFC414"
                                  numberOfStars={5}
                                  name='rating'
                                  starDimension = "20px"
                                  starSpacing = "2px"
                                  />
                                   </div>
                    </div></>
                     : null}
                    <div className="knowmore_amo_dur">
                   
                   
                    <p className="view_amount">₹ {coursesDataDetails.isActiveOffer ? coursesDataDetails.offerPrice : coursesDataDetails.minPrice} /-</p>
                    {coursesDataDetails.isActiveOffer ?
                    <p className="view_amount"><span className="offerAmount"><strike>₹ {coursesDataDetails.minPrice} /-</strike></span></p> : null}
                    <p className="knowmore_duration">Validity : {coursesDataDetails.minTime} days</p>
                    </div>
                    <div className="course_button_position">
                        <button className="course_individual_btn_first" onClick={() => coursesDataDetails.courseTypeId == 2 ? handleBuyNow() : handleSubscription()}>{coursesDataDetails.courseTypeId == 2 ? "Buy Now" : "Individual"}</button>
                        <button className="course_teams_btn_first" onClick={() => handleTeamsRedirect()}>Teams</button>
                    </div>
                    </div>
                    
                  </div>
                </div>
          </div>
        {/* <div className="page_banner_inner">
          <div className="container">
            <div className="course_main">
              <img
                src={coursesDataDetails.coverImage}
                className="img-fluid course_main_img"
                alt="Course main"
              />
              <img src={courseMainImg} className="img-fluid course_main_img"></img>
              
            </div>
            <div className="left"></div>
            <div className="banner_text">
              <h4 className="banner_course_title">{coursesDataDetails.courseName}</h4>
              <p className="banner_course_description">
                {coursesDataDetails.description}
              </p>
            </div>
          </div>
        </div> */}
        {/* <div className="course_info">
          <div className="container">
            <h4 className="course_name_view">
              Learn the {coursesDataDetails.courseName}
            </h4>
            <div className="course_instruction">
              <div className="course_ins_left">
                <div className="instructor">
                  <p className="instructur_heading">Instructor</p>
                  <p className="instructur_name">
                    { 
                      coursesDataDetails && coursesDataDetails.trainer ? getTrainerFullName(coursesDataDetails.trainer) : ''
                    }
                  </p>
                </div>
                <div className="enrolled">
                  <p className="enrolled_heading">Students Enrolled</p>
                  <p className="enrolled_number">
                  {coursesDataDetails.userCount}
                  </p>
                </div>
              </div>
              <div className="course_ins_right">
                <p className="view_amount">₹ {coursesDataDetails.minPrice} /-</p>
                <p className="enrolled_now_btn">
                  <button className="enroll_now_btn" onClick={()=>manageEnroll()}>Enroll Now</button>
                </p>
              </div>
            </div>
            <div className="course_thumbnail">
              <img
                // src={`data:image/png;base64,${coursesDataDetails.coverImage}`}
                src={coursesDataDetails.coverImage}
                className="img-fluid course_thumbnil_img"
                alt="Course thumbnail"
              />
            </div>
          </div>
        </div> */}
        {/* <div className="tab_view">
          <div className="container">
            <TabItems courseTabDetails={coursesDataDetails}/>
            <div className="popular_course">
              <PopularCourse />
            </div>
          </div>
        </div> */}


        


        <div className="container">
        <div className="tab_view">
            <TabItems courseTabDetails={coursesDataDetails} returnTabClick={fetchTabClick}/>
        </div>
        <div className="popular_course">
              <PopularCourse coursesData = {popularCourseData}/>
            </div>
          {/* <div className="overview">
            <div className="overview_Style">
              <h4 className="overview_mod">Overview</h4>
            </div>
          
            <div className="overview_design"
            dangerouslySetInnerHTML={{ __html: htmlContent }}>
            </div>
          </div> */}
          
          
          <div className="course_bottom">
              <div className="imageCourseBottom">
                <img src={selectedTab == 0 ? courseBottomImg : selectedTab == 1 ? courseCurriculumImage: courseBottomImg} className="img-fluid course_bottom_img"></img>
              </div>
              <div className="row buttom_button">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                
                  <button className="course_individual_btn" onClick={() => coursesDataDetails.courseTypeId == 2 ? handleBuyNow() : handleSubscription()}>{coursesDataDetails.courseTypeId == 2 ? "Buy Now" : "Proceed with Individual"}</button>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <button className="course_teams_btn" onClick={() => handleTeamsRedirect()}>Buy for Teams</button>
                  </div>
                </div>
          </div>
              {/* <div className="course_last_button_position">
                  <button className="course_individual_btn">Proceed with Individual</button>
                  <button className="course_teams_btn">Buy for Teams</button>
              </div> */}


              {/* <div className="course_form_main">
            
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <button className="course_individual_btn">Proceed with Individual</button>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <button className="course_teams_btn">Buy for Teams</button>
                  </div>
                </div>
          </div> */}
              
            
      </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default CourseView;
